import CookiesJS from 'cookies-js';
import { notify } from '../notifications';

/**
 * Список покупок: вкладки, переход по категориям и отметки.
 *
 * Вкладка — вариант дня плана. Все вкладки отданы сервером сразу
 * и лежат в разметке: переключение на месте, без перезагрузки,
 * — иначе отметки на странице слетали бы при каждом клике,
 * а список открывают в магазине с телефона
 * (bod-knowledge decisions/shopping-list-structure.md).
 *
 * Отметки хранятся на сервере: список открывают с телефона,
 * а планируют с компьютера, и браузерное хранилище между
 * устройствами не переедет.
 *
 * Слушаем документ целиком, а не корень страницы: навигация стоит
 * в двух местах сразу — в боковой колонке и в листе за тремя точками
 * на телефоне, — и «Очистить» тоже.
 */
export function initShoppingList($, apiClient) {
    if (!$('.shopping__panel').length) return;

    const $document = $(document);
    const userId = ($('.js-shopping-clear').first().attr('data-user-id') || '').trim();

    // Какая вкладка открыта — в адресе страницы. Перезагрузка (а её
    // делают: отметил продукты и обновил) возвращала на первую, хотя
    // человек стоял на третьей (QA 23.10). Адрес, а не хранилище:
    // ссылку на нужный день можно отправить себе же.
    function rememberTab(key) {
        try {
            const url = new URL(window.location.href);
            url.searchParams.set('tab', key);
            window.history.replaceState(null, '', url.toString());
        } catch (error) {
            // Старый браузер без History API — вкладка просто
            // не запомнится, страница от этого не ломается.
        }
    }

    function showTab(key) {
        $('.js-shopping-tab').each(function () {
            $(this).toggleClass('day-tab--active', $(this).attr('data-tab') === key);
        });
        $('.shopping__panel, .shopping-categories').each(function () {
            $(this).toggleClass('is-hidden', $(this).attr('data-tab') !== key);
        });
    }

    // Полоса под категорией — доля отмеченных в ней продуктов.
    // Считается по разметке: она же и есть источник правды на странице.
    // Обновляются обе копии навигации — колонка и лист.
    function refreshBars($panel) {
        const key = $panel.attr('data-tab');
        $(`.shopping-categories[data-tab="${key}"] .shopping-category`).each(function () {
            const code = $(this).attr('data-category');
            const $boxes = $panel.find(`[data-category="${code}"] .js-shopping-mark`);
            const total = $boxes.length;
            const marked = $boxes.filter(':checked').length;
            const percent = total ? Math.round((marked / total) * 100) : 0;
            $(this).find('.shopping-category__bar-fill').css('width', `${percent}%`);
        });
    }

    // На сервер уходит вся раскладка отметок целиком: вариантов
    // немного, а частичные обновления потребовали бы отдельной ручки
    // на каждое действие.
    function collectMarks() {
        const marks = [];
        $('.shopping__panel').each(function () {
            const programmId = $(this).attr('data-programm-id');
            if (!programmId) return;
            const productIds = [];
            $(this).find('.js-shopping-mark:checked').each(function () {
                productIds.push($(this).attr('data-product'));
            });
            if (productIds.length) marks.push({ programmId, productIds });
        });
        return marks;
    }

    // Галочки щёлкают подряд, а уходит всегда последняя раскладка:
    // пока запрос в пути, следующий клик не отправляется сразу,
    // но и не теряется — после ответа уйдёт то, что на экране.
    let saving = false;
    let pending = false;
    async function save() {
        if (!userId) return;
        if (saving) {
            pending = true;
            return;
        }
        saving = true;
        try {
            await apiClient.setShoppingMarks(userId, collectMarks(), CookiesJS.get('auth_token'));
        } catch (error) {
            notify('Не удалось сохранить отметку. Попробуйте ещё раз.', 'error');
            console.error(error);
        } finally {
            saving = false;
            if (pending) {
                pending = false;
                save();
            }
        }
    }

    $document.on('click', '.js-shopping-tab', function () {
        const key = $(this).attr('data-tab');
        showTab(key);
        rememberTab(key);
    });

    // Вкладка из адреса — после перезагрузки и по ссылке.
    try {
        const wanted = new URL(window.location.href).searchParams.get('tab');
        if (wanted && $(`.shopping__panel[data-tab="${wanted}"]`).length) showTab(wanted);
    } catch (error) {
        // см. `rememberTab`
    }

    // Клик по категории — подскролл к первому заголовку её группы.
    // Своим обработчиком, а не якорем браузера: прыжок без плавности
    // в длинном списке читается как подмена страницы.
    $document.on('click', '.js-shopping-anchor', function (event) {
        const id = ($(this).attr('href') || '').replace('#', '');
        const target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        // На телефоне категорию нажимают из листа поверх страницы —
        // его надо закрыть, иначе прокрутка уедет под него.
        const menu = $(this).closest('.client-menu')[0];
        if (menu) {
            menu.hidden = true;
            document.body.style.overflow = '';
        }
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    $document.on('change', '.js-shopping-mark', function () {
        refreshBars($(this).closest('.shopping__panel'));
        save();
    });

    // Снять всё разом можно только здесь: сами мы отметки не трогаем,
    // при пересборке уходят лишь те, чьего варианта не стало.
    $document.on('click', '.js-shopping-clear', function () {
        $('.js-shopping-mark:checked').prop('checked', false);
        $('.shopping-category__bar-fill').css('width', '0%');
        save();
    });
}
